import { RECEIVE_REVISIONS, HIDE_REVISIONS, RECEIVE_DELETED_LOCATIONS } from '../actions/revision-actions'

const revisions = (state=[], action) => {
switch(action.type) {
    case RECEIVE_REVISIONS:
      return action.data
    case HIDE_REVISIONS:
      return { }
    case RECEIVE_DELETED_LOCATIONS:
      return action.data
    default:
      return state
  }
}

export default revisions